
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/lead/essential-tips-to-score-band-8+-in-IELTS-academic-writing-task-1",
      function () {
        return require("private-next-pages/elearning/lead/essential-tips-to-score-band-8+-in-IELTS-academic-writing-task-1.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/lead/essential-tips-to-score-band-8+-in-IELTS-academic-writing-task-1"])
      });
    }
  